import moment from 'moment-timezone';

interface ScanTaskUiStartDate {
  date: number;
  time: {
    hours: number;
    minutes: number;
  };
}

export function convertScanTaskStartDateDbValueToUiValue(startDate: {
  date: string;
  hours: number;
  minutes: number;
}): ScanTaskUiStartDate {
  return {
    date: new Date(startDate.date).getTime() / 1000,
    time: {
      hours: startDate.hours,
      minutes: startDate.minutes,
    },
  };
}

export function convertScanTaskStartDateUiValueToDbValue(startDate: ScanTaskUiStartDate): {
  date: string;
  hours: number;
  minutes: number;
} {
  const milliseconds = new Date(startDate.date * 1000);
  return {
    date: moment(milliseconds).format('MM/DD/YYYY'),
    hours: startDate.time.hours,
    minutes: startDate.time.minutes,
  };
}

export function getCurrentScanTaskStartDateDb(): {
  date: string;
  hours: number;
  minutes: number;
} {
  const currentDate = new Date();
  return {
    date: moment(currentDate.getTime()).format('MM/DD/YYYY'),
    hours: currentDate.getHours(),
    minutes: currentDate.getMinutes(),
  };
}
